"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ratingCatalog = exports.injectCatalog = void 0;
var _i18n = require("../../../i18n/i18n");
var _once = require("../../../util/once");
var _messages = require("../locales/de/messages");
var _messages2 = require("../locales/en/messages");
var _messages3 = require("../locales/es/messages");
var _messages4 = require("../locales/fr/messages");
var _messages5 = require("../locales/it/messages");
var _messages6 = require("../locales/ja/messages");
var _messages7 = require("../locales/pt/messages");
var _messages8 = require("../locales/ru/messages");
const ratingCatalog = {
  de: _messages.messages,
  en: _messages2.messages,
  es: _messages3.messages,
  fr: _messages4.messages,
  it: _messages5.messages,
  ja: _messages6.messages,
  pt: _messages7.messages,
  ru: _messages8.messages
};
exports.ratingCatalog = ratingCatalog;
const injectCatalog = (0, _once.once)(() => {
  (0, _i18n.getI18n)().load(ratingCatalog);
});
exports.injectCatalog = injectCatalog;
//# sourceMappingURL=RatingCatalog.js.map